import React from 'react';
import { Link } from 'react-router-dom';

const BackButtonMin = ({ label, to = { pathname: '/dashboard' }, icon = 'fa-arrow-left' }) => {
  return (
    <Link to={to}>
      <button type="button" className="btn btn-outline-secondary btn-sirio" style={{ borderRadius: '20px' }}>
        <i className={`fa ${icon} mr-2`}></i> {label}
      </button>
    </Link>
  );
};

export default BackButtonMin;
